import Type from 'molbio/maps/Type';
import ProteinAnnotationsView, {
  ProteinAnnotationsViewOptions,
  ProteinAnnotationView,
} from 'molbio/proteins/ProteinAnnotationsView';
import {ProteinAnnotationVersion} from 'molbio/proteins/util/ProteinConstants';
import ProteinAlignmentTabState from 'molbio/tabstates/ProteinAlignmentTabState';

interface ProteinAlignmentAnnotationsViewOptions extends ProteinAnnotationsViewOptions {
  annotations: Array<ProteinAnnotationVersion>;
}

export default class ProteinAlignmentAnnotationsView extends ProteinAnnotationsView {
  tabstate!: ProteinAlignmentTabState;
  annotations!: Array<ProteinAnnotationVersion>;

  constructor(options: ProteinAlignmentAnnotationsViewOptions) {
    super(options);
    this.annotations = options.annotations;
    this.className = 'proteinAlignmentAnnotations';
  }

  getPolymerLength(): number {
    return this.tabstate.getPolymerLength();
  }

  contextMenuOptions(): Array<string> {
    return [];
  }

  shouldSyncToStore(): boolean {
    return false;
  }

  isAnnotationHovered(annotation: ProteinAnnotationVersion): boolean {
    return false;
  }

  isAnnotationSelected(annotation: ProteinAnnotationVersion): boolean {
    return false;
  }

  getProteinId(): string | null {
    return null;
  }

  getAnnotations(): Array<ProteinAnnotationVersion> {
    return this.annotations;
  }

  getResiduesType(): Type {
    return this.tabstate.getType();
  }

  clickAction(e: MouseEvent, d: ProteinAnnotationView): void {
    this.tabstate.get('selection').setEndpoints(d.start(), d.end());
  }

  dblClickAction(e: MouseEvent, d: ProteinAnnotationView): void {}
}
